<template>
  <div>
    <content-show-dialog class="m-1" :fullHeight="true">
      <div slot="info" class="card border-0 mb-2">
        <info-table
          :infoColumns="drawerProperties.tableColumns"
          :infoData="{
            ...drawerProperties.rowData,
            effectTags: drawerProperties.effectTags,
          }"
          :showBusinesses="
            drawerProperties.showBusinessesTag
              ? drawerProperties.showBusinessesTag
              : false
          "
        >
          <template slot="addColumn" v-if="drawerProperties.addColumns">
            <tr
              class="shadow-sm"
              v-for="(addColumn, key) in drawerProperties.addColumns"
              :key="`${key}-${addColumn.label}`"
            >
              <td-info-tag
                :data="drawerProperties.rowData[addColumn.data]"
                :tdLabel="`${addColumn.label}:`"
                :fieldTag="addColumn.field"
                :effect="drawerProperties.effectTags"
              />
            </tr>
          </template>
        </info-table>
      </div>
    </content-show-dialog>
    <div
      class="demo-drawer__footer custom-drawer__footer"
      v-if="drawerProperties.rowData"
    >
      <footer-date-at
        :createdAt="drawerProperties.rowData.created_at"
        :updatedAt="drawerProperties.rowData.updated_at"
      />
    </div>
  </div>
</template>
<script>
import InfoTable from 'src/components/Tables/InfoTable.vue';
import TdInfoTag from 'src/components/Tables/TdInfoTag.vue';

export default {
  name: 'show-as-drawer',
  components: {
    [InfoTable.name]: InfoTable,
    [TdInfoTag.name]: TdInfoTag,
  },
  props: {
    drawerProperties: {
      type: Object,
      required: true,
    },
  },
};
</script>
